'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'PhaseRestService',
    function ($modal, PhaseRestService) {

        return {
            select: select,
            create: create,
            edit: edit,
            api: PhaseRestService
        };

        function select(phase, filters, def) {
            return $modal.open({
                template: require('../view/phase-modal-select.html'),
                controller: 'PhaseModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    phase: function () {
                        return phase;
                    },
                    phaseFilters: function () {
                        return filters != null ? filters : [];
                    },
                    def: () => {
                        return {
                            org: def.org
                        };
                    }
                }
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/phase-modal-create.html'),
                controller: 'PhaseModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    phase: function () {
                        return {
                            org: (function (def) {
                                if (def != null && def.org != null)
                                    return def.org;
                            })(def)
                        };
                    }
                }
            });
        }

        function edit(phase) {
            return $modal.open({
                template: require('../view/phase-modal-create.html'),
                controller: 'PhaseModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    phase: function () {
                        return phase;
                    }
                }
            });
        }

    }];